import React, { createRef, useState } from "react";
import { StyleSheet, ScrollView, View } from "react-native";
import { colors } from "src/assets";
import { UserCard, ActionDialog } from "src/components";
import { NotFound } from "./components";
import { useBlock, useBlockActions } from "src/hooks";
import { IUser } from "src/domains";
import LocalText from "src/local";
let selectedUser: IUser | undefined;

export const BlockedUsersScreen: React.FC = () => {
  const [items, loading] = useBlock();
  const { block, unblock } = useBlockActions();
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const onAction = (index: number) => {
    if (index === 0) {
      if (selectedUser) {
        if (selectedUser.isBlocked) {
          unblock(selectedUser.id);
        } else {
          block(selectedUser.id);
        }
      }
    }
  };
  return (
    <View
      style={[
        styles.container,
        items.length === 0 && !loading ? styles.notFound : {},
      ]}
    >
      {items.length > 0 ? (
        <ScrollView>
          {items.map((item) => (
            <UserCard
              key={item.id}
              contanerStyle={styles.card}
              source={item?.image ? { uri: item?.image } : undefined}
              status={item?.status}
              name={item?.name}
              birthday={item?.birthday}
              gender={item?.gender}
              prefecture={item?.address?.prefecture}
              isVerified={item?.identificationStatus === "APPROVED"}
              onPress={() => {
                selectedUser = item;
                setOpenDialog(true);
              }}
            />
          ))}
        </ScrollView>
      ) : null}
      {items.length === 0 && !loading ? <NotFound /> : null}
      <ActionDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onAction={(index) => {
          setOpenDialog(false);
          onAction(index);
        }}
        items={[LocalText.screens.blockedUsers.unblock].map((key) => ({
          key,
          label: key,
        }))}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
  },
  notFound: {
    backgroundColor: colors.gray1,
  },
  card: {
    marginVertical: 8,
    marginHorizontal: 16,
  },
});
